import { createActions, createReducer } from 'reduxsauce'

import { AuthenticationTypes } from '../authentication/duckAuthentication'

/* Initial State */
const INITIAL_STATE = {
  error: null
}

/**
 * Creating actions and types with reduxsauce.
 */
const { Types, Creators } = createActions({
  saveFertilizer: ['fertilizer', 'onSuccess', 'onError'],
  removeFertilizer: ['fertilizer', 'onSuccess', 'onError'],
  saveFertilizerManufacturer: ['manufacturer', 'onSuccess', 'onError'],
  fertilizerError: ['error']
})

const saveFertilizer = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const removeFertilizer = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const saveFertilizerManufacturer = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const fertilizerError = (state = INITIAL_STATE, { error }) => ({
  ...state,
  error
})

const logout = () => ({ ...INITIAL_STATE })


/**
 * Creating reducer with Types.
 */
export default createReducer(INITIAL_STATE, {
  [Types.FERTILIZER_ERROR]: fertilizerError,

  [Types.SAVE_FERTILIZER]: saveFertilizer,
  [Types.REMOVE_FERTILIZER]: removeFertilizer,

  [Types.SAVE_FERTILIZER_MANUFACTURER]: saveFertilizerManufacturer,

  [AuthenticationTypes.LOGOUT]: logout
})

export {
  Types as FertilizerTypes,
  Creators as FertilizerActions
}
